<template>
  <div>
    <NavBar />
    <div class="container main-container">
      <div class="coupons-header">
        <h3>
          Cupones
        </h3>
        <div class="coupon-count">
          <strong>{{ currentCredit() }}/{{ totalCredit() }}</strong>
        </div>
      </div>
      <v-container fluid grid-list-lg>
      <v-flex xs12>
        <v-slider
          class="slider"
          v-if="this.currentCredit() >= 0 && this.totalCredit() > 0"
          v-model="$store.state.couponsSummary.currentCredit"
          :max="totalCredit()"
          :label="totalCredit()"
          thumb-label="always"
          thumb-color="rgb(221, 100, 0)"
          inverse-label
          readonly
        />
      </v-flex>
      </v-container>
      <v-flex xs12>
        <OrdersSummary
          :ordersSummary="$store.state.ordersSummary"
        />
      </v-flex>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar"
import OrdersSummary from "../components/OrdersSummary"

export default {
  name: "coupons",
  created() {
    this.fetch();
  },
  components: {
    NavBar,
    OrdersSummary
  },
  data: function() {
    return {
      currentCredit: () => {
        return this.$store.state.couponsSummary.currentCredit;
      },
      totalCredit: () => {
        return String(this.$store.state.couponsSummary.totalCredit);
      }
    };
  },
  methods: {
    fetch: function() {
      this.$Progress.start();
      let url = this.$store.state.connection.url;
      /*
      Why is the POST method being used instead of a GET request?
      the XMLHttpRequest#send method does not send a body when performing
      a GET request, and odoo's json request handling throws a 400 error
      when not specifying a body in json requests.
      */
      this.$http
        .post(url + "coupons", {
          body: {}
        })
        .then(result => {
          this.$Progress.finish();
          let summary = {
            totalCoupons: result.body.result.total_coupons,
            totalCredit: result.body.result.total_credit,
            currentCredit: result.body.result.current_credit,
            rejectedOrders: result.body.result.rejected_orders
          };
          this.$store.commit("updateCouponsSummary", summary);
        })
        .catch(err => {
          console.log(err);
          this.$Progress.finish();
        });
    }
  }
};
</script>
<style scoped>
.container {
  margin-top: 10%;
}
.coupons-header {
  display: inline-flex;
  padding-top: 5%;
  align-items: center;
}
.coupon-count {
  padding-left: 15%;
}
.slider {
  color: rgb(221, 100, 0) !important;
}
</style>
